import KunLoading107 from './src/index'

KunLoading107.install = function (Vue) {
	Vue.component(KunLoading107.name, KunLoading107);
}

export default KunLoading107;
